import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import MatxLayout from './components/MatxLayout/MatxLayout';
import { MartProvider } from "./contexts/mart/MartContext";
import { AllProductsProvider } from "./contexts/productContext/AllProductsContext";
import { checkRoleExist } from "./utils/utils";
import adminsRoutes from "./views/admins/AdminRoutes";
import bannerRoutes from "./views/banners/BannerRoutes";
import campaignsRoutes from "./views/campaigns/CampaignRoutes";
import categoriesRoutes from "./views/categories/CategoriesRoutes";
import contactUsRoutes from "./views/contact-us/ContactUsRoutes";
import couponsRoutes from "./views/coupon/CouponRoutes";
import customerRoutes from "./views/customers/CustomerRoutes";
import dashboardRoutes from './views/dashboard/DashboardRoutes';
import feedbackRoutes from "./views/feedback/FeedbackRoutes";
import martRoutes from "./views/mart/MartRoutes";
import notificationRoutes from "./views/notifications/NotificationRoutes";
import orderRoutes from "./views/orders/OrderRoutes";
import productsRoutes from "./views/products/ProductsRoutes";
import attributesRoutes from "./views/products/attributes/AttributesRoutes";
import riderRoutes from "./views/riders/RiderRoutes";
import saleRoutes from "./views/sales/SaleRoutes";
import sellerRoutes from "./views/sellers/SellerRoutes";
import NotFound from './views/sessions/NotFound';
import SessionOut from "./views/sessions/SessionOut";
import sessionRoutes from './views/sessions/SessionRoutes';
import shippingRoutes from "./views/shipping/ShippingRoutes";

const routes = [
    {
        element: (
            <AuthGuard>
                <AllProductsProvider><MartProvider><MatxLayout /></MartProvider></AllProductsProvider>
            </AuthGuard>
        ),
        children: [...dashboardRoutes, ...feedbackRoutes, ...contactUsRoutes],
    },
    ...sessionRoutes,
    { path: '/', element: <Navigate to="dashboard/default" /> },
    { path: '/product/', element: <Navigate to="/product/all" /> },
    { path: '/shipping/', element: <Navigate to="/shipping/all" /> },
    { path: '/shipping/', element: <Navigate to="/shipping/all" /> },
    { path: '/session_out', element: <SessionOut /> },
    { path: '*', element: <NotFound /> },
];

const screens = [
    { 
        name: "products", 
        child: productsRoutes 
    },
    { 
        name: "Orders",
        child: orderRoutes 
    },
    { 
        name: "Notifications",
        child: notificationRoutes 
    },
    { 
        name: "Product_Attribute",
        child: attributesRoutes 
    },
    { name: "Product_Category",
    child: categoriesRoutes },
    { name: "Product_Category",
    child: martRoutes },
    { name: "shipping",
    child: shippingRoutes },
    { name: "Sale",
    child: saleRoutes },
    { name: "Sale",
    child: campaignsRoutes },
    { name: "Coupons",
    child: couponsRoutes },
    { name: "Banner_Add",
    child: bannerRoutes },
    { name: "Sellers",
    child: sellerRoutes },
    { name: "Customers",
    child: customerRoutes },
    { 
        name: "Admins",
        child: adminsRoutes 
    }, 
    { name: "Riders", child: riderRoutes }
];

screens.map(screen => {
    if (checkRoleExist(screen.name)) {
        routes[0].children.push.apply(routes[0].children, screen.child);
    }
});

export default routes;
